import { render, staticRenderFns } from "./AgendamentosLista.vue?vue&type=template&id=a362040a&scoped=true&"
import script from "./AgendamentosLista.vue?vue&type=script&lang=js&"
export * from "./AgendamentosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a362040a",
  null
  
)

export default component.exports